import { useCallback, useEffect, useState } from 'react';
import { Categorie, categoriesService } from '../../../apiServices/categories.service';


export const useAllCategories = () => {
  const [categories, setCategories] = useState<Categorie[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = useCallback(async () => {
    setLoading(true);

    try {
      const data = await categoriesService.getAll();
      setCategories(data);
    } catch (err) {
      setError("Error loading categories");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return {
    categories,
    loading,
    error,
    refetch: fetchCategories,
  };
};
